import { observable, computed, action } from "mobx";
import { getRegisteredDomain } from "../utils/domains";
import { mapGetOrCreate } from "../utils/mapGetOrCreate";
import { DomainPair, CookieNameAndValue, RecordingStatisticsForCookie } from "./Cookie";
import { OptionallyObservableMap } from "../../State/EvidenceDB/DatabaseTypes";

export const getCookieKey = ({ sourceDomain, destinationDomain, name }: DomainPair & {name: string}) =>
	`${sourceDomain}\0${destinationDomain}\0${name}` as const;
export type CookieKey = ReturnType<typeof getCookieKey>;


export class CookiesObserver {
	private _cookies = observable.map<CookieKey, OptionallyObservableMap<string, CookieNameAndValue & DomainPair>>();
	private _bySourceDomainDestinationDomain = observable.map<string, OptionallyObservableMap<string, OptionallyObservableMap<string, CookieNameAndValue>>>();
	private _bySourceRegisteredDomainDestinationRegisteredDomain = observable.map<string, OptionallyObservableMap<string, OptionallyObservableMap<string, CookieNameAndValue>>>();
//	private _cookiesByRegisteredDomain = observable.map<RegisteredDomainPairKey, Map<string, CookieNameAndValue & RegisteredDomainPair>>();

	@computed get mapFromKeyToRecordingStatisticsForCookies() {
		return this._cookies;
	}

	@computed get recordingStatisticsForAllCookies() {
		return [...this.mapFromKeyToRecordingStatisticsForCookies.values()];
	}

	@computed get bySourceDomainDestinationDomain() {
		return this._bySourceDomainDestinationDomain;
	}

	@computed get bySourceRegisteredDomainDestinationRegisteredDomain() {
		return this._bySourceRegisteredDomainDestinationRegisteredDomain;
	}

	integrateChanges = action((updates: RecordingStatisticsForCookie[]) => {
		for (const update of updates) {
			const {name, value, sourceDomain, destinationDomain} = update;
			mapGetOrCreate(
				this._cookies,
				getCookieKey(update),
				() => observable.map()
			).set(name, update);;
			mapGetOrCreate(
				mapGetOrCreate(
					this._bySourceDomainDestinationDomain,
					sourceDomain,
					() => observable.map()
				),
				destinationDomain,
				() => observable.map()
			).set(name, {name, value});
			const sourceRegisteredDomain = getRegisteredDomain(sourceDomain);
			const destinationRegisteredDomain = getRegisteredDomain(destinationDomain);
			if (sourceRegisteredDomain != null && destinationRegisteredDomain != null) {
				mapGetOrCreate(
					mapGetOrCreate(
						this._bySourceRegisteredDomainDestinationRegisteredDomain,
						sourceRegisteredDomain,
						() => observable.map()
					),
					destinationRegisteredDomain,
					() => observable.map()
				).set(name, {name, value});
			}
		}
	});

	constructor(changes: RecordingStatisticsForCookie[] = []) {
		this.integrateChanges(changes);
	}

}

